import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useState } from 'react';
import { Button, Stack, Typography } from '../../atoms';
import { styled } from '../../legacy/utils';
import { LogoLoaderWithBackdrop } from '../PageLoader';
import { ImagePreview } from './';
/**
 * `CameraButton` is used for mobile devices when users
 * need to take a picture and upload save it in a form.
 *
 */
// TODO correct button size and padding (consistency with the legacy and atoms buttons)
export function CameraButton({ text, capture, accept = 'images/*', variant, handleImageBlob, resetImageBlob, imageURL, showImagePreview = true, errorMessage, dataName, loading, loadingTitle, }) {
    const [error, setError] = useState(undefined);
    const onImageChange = (event) => {
        const files = event.target.files;
        if (files && files[0]) {
            const file = files[0];
            const fileType = file.type;
            if (!accept.includes(fileType) &&
                fileType.split('/')[0] &&
                !accept.includes(fileType.split('/')[0])) {
                setError(errorMessage);
                return;
            }
            handleImageBlob(file);
            setError(undefined);
            // necessary so the same file can be uploaded, deleted,
            // and then uploaded again
            event.target.value = '';
        }
    };
    if (loading) {
        return _jsx(LogoLoaderWithBackdrop, { title: loadingTitle, open: true });
    }
    return (_jsxs(Stack, { rowGap: 3, columnGap: 3, alignItems: "center", justifyContent: "flex-end", children: [!!imageURL && showImagePreview && (_jsx(ImagePreview, { resetImageBlob: resetImageBlob, imageURL: imageURL })), !imageURL && (_jsx(Button, { variant: variant, icon: "camera-outline", component: "div", children: _jsxs("label", { htmlFor: "picture", "data-name": dataName, children: [text, _jsx(VisuallyHiddenInput, { onChange: onImageChange, type: "file", id: "picture", accept: accept, capture: capture })] }) })), error && (_jsx(Typography, { variant: "body1 regular", color: "error", children: error }))] }));
}
const VisuallyHiddenInput = styled('input')({
    display: 'none',
});
